import React, { memo } from 'react';
import { activeAccountNameSelector, cookActiveAccountForSelectors } from '@signal/core/auth';
import { useContextsInReduxForm } from '@signal/core/contextFetch/hooks';
import { nameSelector, initialsSelector, emailSelector, cookUserDetailsForSelectors } from '@signal/core/user';
import { ActiveAccountContext, UserDetailsContext } from '@signal/core/user/Context';
import { Wrapper, Avatar, Details, PrimaryDetail, SecondaryDetail } from './styles';
var REDUX_COOKERS = [{
  context: ActiveAccountContext,
  cookers: [cookActiveAccountForSelectors]
}, {
  context: UserDetailsContext,
  cookers: [cookUserDetailsForSelectors]
}];
export function UserDetailsBadge() {
  var selectorState = useContextsInReduxForm(REDUX_COOKERS);
  var name = nameSelector(selectorState);
  var initials = initialsSelector(selectorState);
  var email = emailSelector(selectorState);
  var accountName = activeAccountNameSelector(selectorState);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Avatar, null, initials), /*#__PURE__*/React.createElement(Details, null, /*#__PURE__*/React.createElement(PrimaryDetail, {
    variant: "body4"
  }, accountName), /*#__PURE__*/React.createElement(SecondaryDetail, {
    variant: "body3"
  }, name), /*#__PURE__*/React.createElement(SecondaryDetail, {
    variant: "body3"
  }, email)));
}
export default /*#__PURE__*/memo(UserDetailsBadge);